<template #content>
    <Dialog
        :visible="visible"
        @update:visible="updateVisible"
        header="Alterar Responsável"
        @show="onShow"
        @hide="onHide"
        class="w-11 lg:w-3"
        modal >
        <form @submit.prevent="onSubmit(form)">
            <div class="w-full">
                <div class="field mt-4">
                    <FloatLabel>
                        <Select v-model="form.responsavel_id"
                            :options="responsavelOpt" optionLabel="nome" filter :loading="isLoadingResponavelOpt"
                            class="w-full" optionValue="id" />
                        <label>Responsável</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['responsavel_id'] }}</div>
                </div>
            </div>

            <div class="flex justify-content-end gap-1">
                <Button
                        type="submit"
                        label="Salvar"
                        severity="success"
                        icon="pi pi-save"
                        size="small"
                        class="flex align-items-center justify-content-center"
                        :loading="isLoading" />
                    <Button
                        label="Fechar"
                        severity="warn"
                        icon="pi pi-times"
                        size="small"
                        @click="updateVisible(false)"
                        class="flex align-items-center justify-content-center"
                        :loading="isLoading" />
            </div>
        </form>

    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import Checkbox from 'primevue/checkbox';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import Button from 'primevue/button';
import Select from 'primevue/select';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';

import Contrato from '@/service/contrato.js';
import Usuario from '@/service/usuario.js';

export default {
    components: { 
        Dialog,
        InputGroup,
        InputGroupAddon,
        FloatLabel,
        InputText,
        Checkbox,
        Select,
        Button,
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        contratos: {
            type: Array,
            default: []
        },
        permissoes: {},
    },
    emits: ['submit','close'],
    data() {
        return {
            form: {},
            isLoading: false,
            visibleClienteListaSelect: false,

            responsavelOpt: [],
            isLoadingResponavelOpt: false,

            errors: {},

            visibleAuthForm: false,

            STATUS: constantes.UPLOAD,
        }
    },
    methods: {
        onShow() {
            this.loadUsuarioOpt();
        },
        onHide() {
            this.form = {};
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        onSubmit(form) {
            this.msg    = null;
            this.errors = {};

            this.sendSubmit(form);
        },
        onSubmitAuth(formAuth) {
            const contrato = {...this.form};
            contrato.autorization = formAuth;

            this.sendSubmit(contrato);
        },
        sendSubmit(form) {
            const contratos = [];
            this.contratos.forEach(contrato => {
                contratos.push(contrato.id);
            });
            form.contratos = contratos;

            this.errors = {};
            this.isLoading = true;
            Contrato.updateResponsavel(form)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Seus dados foram salvos com sucesso.', life: 3000 });

                    this.visibleAuthForm = false;

                    this.$emit('save');
                    this.$emit('close');
                })
                .catch(error => {
                    if(error.response) {
                        let err = error.response.data;
                        this.visibleAuthForm = (err.auth == true);
                        if(err.msg) {
                            this.msg = err.msg;
                        }
                        
                        if(err.erros && Object.getPrototypeOf(err.erros)) {
                            for(let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                            return;
                        }
                        if(err.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: err.msg, life: 5000 });
                            return;
                        }
                    }
                    this.visibleAuthForm = false;
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        loadUsuarioOpt() {
            this.isLoadingResponavelOpt = true;
            Usuario.option(['order[nome]=asc'].join("&"))
                .then(response => {
                    let responsaveis    = [{ id: 0, nome: "[SEM RESPONSAVEL]" }];
                    this.responsavelOpt = responsaveis.concat(response.data);
                })
                .finally(() => {
                    this.isLoadingResponavelOpt = false;
                });
        },
    },
}
</script>
